import { c as _c } from "react/compiler-runtime";
import { css, cx } from '@repo/pandacss/css';
import type { ReactNode } from 'react';
import type { CommonProps } from '../types';
export type SimpleDetailsProps = CommonProps & {
  variant: 'simple';
  SummaryComponent: ReactNode;
};
const detailsBaseStyles = css.raw({
  position: 'relative',
  '& [data-icon="expand-more"]': {
    transitionProperty: '[transform]',
    transitionDuration: '[0.3s]',
    transitionTimingFunction: 'ease'
  },
  '&[open] [data-icon="expand-more"]': {
    transform: '[rotate(-180deg)]'
  },
  '&:not([open]) [data-icon="expand-more"]': {
    transform: '[rotate(0deg)]'
  }
});
const summaryBaseStyles = css.raw({
  listStyleType: 'none',
  _marker: {
    display: 'none'
  },
  cursor: 'pointer'
});
export function SimpleDetails(t0) {
  const $ = _c(17);
  const {
    children,
    detailsProps: t1,
    summaryProps: t2,
    SummaryComponent
  } = t0;
  let restSummaryProps;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== t1 || $[1] !== t2) {
    const detailsProps = t1 === undefined ? {} : t1;
    const summaryProps = t2 === undefined ? {} : t2;
    const {
      className: detailsClassName,
      css: detailsCss,
      ...restDetailsProps
    } = detailsProps;
    const {
      className: summaryClassName,
      css: summaryCss,
      ...t7
    } = summaryProps;
    restSummaryProps = t7;
    t5 = cx(css(detailsBaseStyles, detailsCss), detailsClassName);
    t6 = restDetailsProps;
    t3 = "detail-summary";
    t4 = cx(css(summaryBaseStyles, summaryCss), summaryClassName);
    $[0] = t1;
    $[1] = t2;
    $[2] = restSummaryProps;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    restSummaryProps = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== SummaryComponent || $[8] !== restSummaryProps || $[9] !== t3 || $[10] !== t4) {
    t7 = <summary data-testid={t3} className={t4} {...restSummaryProps}>{SummaryComponent}</summary>;
    $[7] = SummaryComponent;
    $[8] = restSummaryProps;
    $[9] = t3;
    $[10] = t4;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== children || $[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = <details className={t5} {...t6}>{t7}{children}</details>;
    $[12] = children;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}